import { z } from 'zod';
import { CursorPagination } from './common.js';
export const ConversationMessage = z.object({
    id: z.string().uuid(),
    conversationId: z.string().uuid(),
    direction: z.enum(['in', 'out']),
    text: z.string(),
    sentBy: z.string(), // 'system' | sales user id
    ts: z.string().datetime(),
    tgMessageId: z.string().nullable(),
});
export const ListMessagesQuery = CursorPagination;
export const SendMessageRequest = z.object({
    text: z.string().min(1).max(4096),
});
export const SendMessageResponse = z.object({
    message: ConversationMessage,
});
/**
 * Conversation view served at GET /api/sales/leads/:id/conversation.
 * Returns the full message history (in chronological order — small N
 * per lead, no pagination needed for MVP).
 */
export const ConversationDetail = z.object({
    id: z.string().uuid(),
    leadId: z.string().uuid(),
    accountId: z.string().uuid(),
    accountLabel: z.string().nullable(), // "@tgUsername" or phone, for sales UX
    targetUserId: z.string().nullable(),
    status: z.enum(['open', 'closed']),
    lastMsgAt: z.string().datetime().nullable(),
    messages: z.array(ConversationMessage),
});
//# sourceMappingURL=conversation.js.map